import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getSeniorList} from "../../../api/seniorApi";
import {SeniorFormData} from "../../../interface/SeniorFormData";
import {EmptyState} from "../../../components/common/EmptyStateProps";

export default function SeniorList() {
    const [seniors, setSeniors] = useState<SeniorFormData[]>([]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getSeniorList();
                setSeniors(res.data.data);
            } catch (error) {
                console.error("Failed to fetch seniors:", error);
            } finally {
            }
        };
        fetchData();
    }, []);
    if (!seniors || seniors.length === 0) {
        return (<>
            <div className="bottom-btn">
                <button
                    id=""
                    type="button"
                    className="btn confirm"
                    onClick={() => window.location.href = '/seniorAdd'}
                >
                    신규 등록
                </button>
            </div>
            <main className="container type_gray">
                <section>
                    <div className="inner-box">
                        <EmptyState message="어르신 목록이 비어있습니다."/>
                    </div>
                </section>
            </main>
        </>);
    }
    return (
        <>
            <div className="bottom-btn">
                <button
                    id=""
                    type="button"
                    className="btn confirm"
                    onClick={() => window.location.href = '/seniorAdd'}
                >
                    신규 등록
                </button>
            </div>
            {/*//bottom-btn*/}
            {/*container*/}
            <main className="container type_gray">
                <section>
                    <div className="inner-box">
                        {seniors.map((senior, index) => (
                            <div key={index} className="round-box">
                                <div className="round-body">
                                    <ul className="text-menu">
                                        <li>
                                            <Link to={`/senior/${senior.seniorCode}`}>
                                                {senior.name}
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </main>
        </>
    );
}
